import reducer from "./reducer";
export { default as Dialog } from "./components/index";
export { default as dialogReducerName } from "./constants";
export default reducer;
